export default __webpack_public_path__ + "static/media/codeVideo.c03a5ca6.mp4";